<template>
  <div style="width: 100%">
    <canvas style="width:100%; height: 100%" ref="signatureCanvas"/>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import SignaturePad from "signature_pad";

const props = defineProps({
  initialSignature: {
    type: String,
    default: null,
  }
});

const signatureCanvas = ref();
let signaturePad: SignaturePad;

const emit = defineEmits(['endStroke']);

function isEmpty() {
  return signaturePad.isEmpty();
}

function getSignature(): string {
  const dataURL = signaturePad.toDataURL('image/png');
  return dataURL.split(',')[1];
}

function clearSignature() {
  signaturePad.clear();
}

function fromDataURL(dataURL: string) {
  signaturePad.fromDataURL(dataURL);
}

onMounted(() => {
  if (signatureCanvas.value) {
    signatureCanvas.value.width = signatureCanvas.value["clientWidth"];
    signatureCanvas.value.height = signatureCanvas.value["clientHeight"];
    signaturePad = new SignaturePad(signatureCanvas.value, {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgba(0, 0, 0, 255)',
    });
    if (props.initialSignature) {
      signaturePad.fromDataURL(`data:image/png;base64,${props.initialSignature}`);
    }
    signaturePad.addEventListener("endStroke", () => {
      const signature = getSignature();
      console.log("Signature ended");
      emit('endStroke', signature);
    }, { once: false });
  }
});

defineExpose({
  isEmpty,
  getSignature,
  clearSignature,
  fromDataURL,
});
</script>

<style scoped>

</style>
